

<style  scoped>

.langdesc {
	display: inline-block;
	vertical-align: middle;
	margin-left: 40px;
  font-family: 'Ropa Sans', sans-serif;
}

@media (max-width:579px) {
	.langdesc {
		margin-left: 0
	}
}
.footer{
	display: inline-block;
	position: fixed;
	bottom: 40px;
	left: calc(100vw - 60px);
	text-transform: uppercase;
	font-size: 14px;
	letter-spacing: .15em;
	font-weight: 300;
	-webkit-font-smoothing: auto;
	-moz-osx-font-smoothing: auto;
	z-index: 1;
  color:#ffffff;
}

@media (max-width:1199px) {
	.footer{
		bottom: 30px;
		left: calc(100vw - 30px)
	}
}

@media (max-width:1023px) {
	.footer{
		bottom: 20px;
		left: calc(100vw - 20px)
	}
}

@media (max-width:767px) {
	.footer
	{
		right: 0;
		bottom: 0;
		left: 0;
		height: 75px;


	}
}

@media (max-width:440px) {
	.footer{
		height: 55px
	}
}

.footer .inner{
	position: absolute;
	bottom: 0;
	right: 0;
	white-space: nowrap
}

@media (max-width:767px)
{
	.footer .inner
	{
		display: -ms-flexbox;
		display: flex;
		-ms-flex-pack: end;
		justify-content: flex-end;
		-ms-flex-align: center;
		align-items: center;
		position: static;
		height: 100%;
		width: 100%;
		padding-left: 30px;
		padding-right: 30px;
		white-space: nowrap
	}
}

@media (max-width:579px)
 {
	.footer .inner{
		-ms-flex-pack: justify;
		justify-content: space-between;
		padding-left: 0
	}
}

.langs{
	display: inline-block;
	vertical-align: middle
}

@media (max-width:579px)
{
	.langs{
		display: -ms-flexbox;
		display: flex;
		height: 100%
	}
}

.langs .lang{
	opacity: 1
}

@media (max-width:579px) {
	.langs .lang{
		display: -ms-flexbox;
		display: flex;
		-ms-flex-pack: center;
		justify-content: center;
		-ms-flex-align: center;
		align-items: center;
		height: 100%;
		padding-left: 20px;
		padding-right: 20px;
		border-right: 1px solid hsla(0, 0%, 100%, .05)
	}
}

.langs .lang:not(:last-child):after {
	content: ".";
	display: inline-block;
	margin-left: 8px;
	margin-right: 8px;
	color: #8e8e8e
}

@media (max-width:579px) {
	.langs .lang:not(:last-child):after {
		display: none
	}
}

.langs .lang.active .label,
.langs .lang:hover .label{
	opacity: 1

}

.langs .lang .label{
	opacity: .5;
	transition: opacity .1s;
	will-change: opacity;
  color:#fff;
}



marine-holdings {
	display: inline-block;
	vertical-align: middle;
	margin-left: 105px
}

@media (max-width:1199px) {
	marine-holdings {
		margin-left: 85px
	}
}

@media (max-width:1023px) {
	marine-holdings {
		margin-left: 45px
	}
}

@media (max-width:579px) {
	marine-holdings {
		margin-left: 0
	}
}

marine-holdings .label {
	color: #8e8e8e
}

@media (max-width:480px) {
	marine-holdings .label {
		display: block;
		text-align: right
	}
}

marine-holdings .link {
	white-space: nowrap
}

marine-holdings .link .letter {
	opacity: .8;
	will-change: opacity
}

marine-holdings .link .letter:first-child {
	transition-delay: .3s
}

marine-holdings .link .letter:nth-child(2) {
	transition-delay: .25s
}

marine-holdings .link .letter:nth-child(3) {
	transition-delay: .35s
}

marine-holdings .link .letter:nth-child(4) {
	transition-delay: .2s
}

marine-holdings .link .letter:nth-child(5) {
	transition-delay: 0s
}

marine-holdings .link .letter:nth-child(6) {
	transition-delay: .05s
}

marine-holdings .link .letter:nth-child(7) {
	transition-delay: .45s
}

marine-holdings .link .letter:nth-child(8) {
	transition-delay: .6s
}

marine-holdings .link .letter:nth-child(9) {
	transition-delay: .25s
}

marine-holdings .link .letter:nth-child(10) {
	transition-delay: .4s
}

marine-holdings .link .letter:nth-child(11) {
	transition-delay: 0s
}

marine-holdings .link:hover .letter {
	opacity: 1
}


.main-logo {
	display: inline-block;
	position: fixed;
	bottom: 65px;
	left: 50px;
	height: 41px;
	width: 128px;
	opacity: 1;
	transition: opacity .3s;
	z-index: 2
}

@media (max-width:1199px) {
	.main-logo {
		bottom: 65px;
		left: 50px
	}
}

@media (max-width:1023px) {
	.main-logo {
		bottom: 65px;
		left: 50px
	}
}

@media (max-width:579px)
{
	.langs
	{
		display: none;
	}
	.footer
	{
		background: transparent;
	}
	.main-logo
	{
		top: 15px;
		bottom: auto;
		height: 41px;
		width: 95px;
		left: 20px;
	}
	.main-logo img
	{

		height: 65px;
		width: 150px;
	}
	.logotopoff .main-logo
	{
		 opacity: 0;
	}
}

.main-logo.v-enter,
.main-logo.v-leave-to {
	opacity: 0
}

.footerone.is-clear .logodowncolorclear
{
   opacity: 1;
	 display: inline-block;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    -webkit-transition: opacity .55s cubic-bezier(.165, .84, .44, 1);
    transition: opacity .55s cubic-bezier(.165, .84, .44, 1);
}
.footerone.is-clear .logodowncolordark
{
   opacity: 0;
	 display: none;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    -webkit-transition: opacity .55s cubic-bezier(.165, .84, .44, 1);
    transition: opacity .55s cubic-bezier(.165, .84, .44, 1);
}
.footerone.is-dark .logodowncolordark
{
   opacity: 1;
	 display: inline-block;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    -webkit-transition: opacity .55s cubic-bezier(.165, .84, .44, 1);
    transition: opacity .55s cubic-bezier(.165, .84, .44, 1);

}
.footerone.is-dark .logodowncolorclear
{
   opacity: 0;
	 display: none;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    -webkit-transition: opacity .55s cubic-bezier(.165, .84, .44, 1);
    transition: opacity .55s cubic-bezier(.165, .84, .44, 1);

}
.footerone.is-dark .langs .lang .label{
  color: #000;
}
.footerone.is-clear .langs .lang .label{
    color: #fff;
}
.footerone.is-dark .langdesc{
  color: #000;
}
.footerone.is-clear .langdesc{
    color: #fff;
}
@media (max-width:px) {
	.scroll .label {
		left: 0px;
		font-size: 10px
	}
}


</style>
<template>
<footer  class="footer footerone"  :class="{ 'is-clear': 'clear'===color , 'is-dark': 'dark'===color}">
  <div  class="inner">
      <span  class="langs"><router-link   :class="{'active':$route.params.lang=='en'}" :to="{ name: $route.name, params: { lang:'en'}}"  class="lang">
            <span  class="label">en</span>
        </router-link>
        <router-link   :class="{'active':$route.params.lang=='fr'}" :to="{ name: $route.name, params: { lang: 'fr'}}"  class="lang">
            <span  class="label">fr</span>
        </router-link>
        <router-link   :class="{'active':$route.params.lang=='de'}" :to="{ name: $route.name, params: { lang: 'de'}}"  class="lang">
            <span  class="label">de</span>
        </router-link>
        
      </span>

       </div>

     </footer>

</template>
<script>

export default
{
    name: "app-footer-one",
    props:
     {
           mainLogoVisible:
          {
              type: Boolean,
              default: !0
           },
					 color: {
							 type: String,
							 default: ""
					 },
					 isfirstLoading: {
						 type: Boolean,
						 default: !0
					 }

    },
		mounted: function()
		{


		},
		methods:
		{




		}
}
</script>
